import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHook } from '../components/OpeningHook';
import { ProblemSection } from '../components/ProblemSection';
import { FailedApproaches } from '../components/FailedApproaches';
import { UniqueMechanism } from '../components/UniqueMechanism';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoIsFor } from '../components/WhoIsFor';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="min-h-screen bg-[#0f172a] font-sans selection:bg-amber-500/30 selection:text-amber-200" data-id="element-190">
      <HeroSection data-id="element-191" />
      <OpeningHook data-id="element-192" />
      <ProblemSection data-id="element-193" />
      <FailedApproaches data-id="element-194" />
      <UniqueMechanism data-id="element-195" />
      <WhatYouGet data-id="element-196" />
      <WhoIsFor data-id="element-197" />
      <HowItWorks data-id="element-198" />
      <ProofSection data-id="element-199" />
      <FAQSection data-id="element-200" />
      <OfferSection data-id="element-201" />
      <Footer data-id="element-202" />
    </main>;
}